import { AsyncPipe } from '@angular/common'
import { afterNextRender, ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'

import { AuthService } from '@auth0/auth0-angular'
import { TranslateModule } from '@ngx-translate/core'
import { filter, takeUntil, tap } from 'rxjs'

import { MailApiService } from '~/core/api'
import { DestroyDirective } from '~/core/directives'
import { UiFacade, UserFacade } from '~/core/features'
import { FORECAST_LIST_PATH } from '~const/index'

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [AsyncPipe, TranslateModule],
})
export class WelcomeComponent {
  private readonly auth0Service = inject(AuthService, { optional: true })
  private readonly mailApiService = inject(MailApiService)
  private readonly router = inject(Router)
  private readonly destroy$ = inject(DestroyDirective).destroy$

  private readonly userFacade = inject(UserFacade)

  uiFacade = inject(UiFacade)

  form: FormGroup = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    company: new FormControl('', Validators.required),
    message: new FormControl(''),
  })

  inRequest = false

  constructor() {
    afterNextRender(() => {
      this.userFacade.user$
        .pipe(
          filter(user => Boolean(user)),
          tap(() => {
            setTimeout(() => {
              // TODO: Tmp solution, remove after implementing user guard fixes
              this.router.navigate(['/', FORECAST_LIST_PATH])
            }, 1000)
          }),
          takeUntil(this.destroy$)
        )
        .subscribe()
    })
  }

  submit(): void {
    this.inRequest = true

    const firstName = this.form.get('firstName')?.value
    const lastName = this.form.get('lastName')?.value
    const email = this.form.get('email')?.value
    const company = this.form.get('company')?.value
    const message = this.form.get('message')?.value

    this.mailApiService
      .testEmail(firstName, lastName, email, company, message)
      .pipe(
        tap(res => {
          this.inRequest = false
          res
            ? this.uiFacade.addSuccessNotification({ i18nTitle: 'notification.mailWasSent' })
            : this.uiFacade.addErrorNotification({ i18nTitle: 'notification.unknownError' })
        })
      )
      .subscribe()
  }

  login(): void {
    this.auth0Service?.loginWithRedirect()
  }
}
